import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";
import { DnDBypassProvider } from "@/components/builder/utils/bypass-context";

import { FormCheckBoxMultiContainerBlock, FormCheckBoxMultiInputBlock, FormCheckBoxMultiLabelBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

function FormCheckBoxMultiPreview({ ...props }) {
  const { field: { field_options } } = useFormFieldContext()

  return <BasePreview {...props}>
    <div>
      {field_options?.map((option, index) => <div key={`checkbox-container-div-${index}`}>
        <DnDBypassProvider data={option}>
          <Element key={`checkbox-container-${index}`} is={FormCheckBoxMultiContainerBlock} id={`checkbox-container-${index}`}>
            <Element key={`checkbox-input-${index}`} is={FormCheckBoxMultiInputBlock} id={`checkbox-input-${index}`} />
            <Element key={`checkbox-label-${index}`} is={FormCheckBoxMultiLabelBlock} id={`checkbox-label-${index}`} />
          </Element>
        </DnDBypassProvider>
      </div>)}
    </div>
  </BasePreview>
}

export default define('form-checkbox-multi', FormCheckBoxMultiPreview, Fragment)
  .shared(prop.share('FormCheckboxMulti', 'form-checkbox-multi'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

